<template>
  <el-dialog title="移动到分组" :visible="visible" @update:visible="$emit('update:visible', $event)" width="400px">
    <el-form :model="form" ref="form" label-width="80px">
      <el-form-item label="选择分组" prop="groupId">
        <el-select v-model="form.groupId" placeholder="请选择分组">
          <el-option
            v-for="group in groups"
            :key="group.id"
            :label="group.name"
            :value="group.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MoveFriendDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    friendId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      groups: [],
      form: {
        groupId: null
      }
    }
  },
  created() {
    // this.loadGroups()
  },
  mounted() {
    // 确保组件实例化完成后再绑定方法
    this.loadGroups = this.loadGroups.bind(this)
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadGroups()
        }
      }
    }
  },
  methods: {
    async loadGroups() {
      try {
        const res = await this.$http.get('/friend/group/list')
        this.groups = res
      } catch (error) {
        this.$message.error('加载分组失败')
      }
    },
    async onSubmit() {
      if (!this.form.groupId) {
        this.$message.warning('请选择分组')
        return
      }
      try {
        await this.$http.post('/friend/group/move', null, {
          params: {
          friendId: this.friendId,
          groupId: this.form.groupId
          }
        })
        this.$message.success('移动成功')
        this.$emit('success')
        this.$emit('update:visible', false)
      } catch (error) {
        this.$message.error('移动失败')
      }
    }
  }
}
</script>
